import {Translate} from '@mavismart_frontend/components/translate';

export const PAGINATION_MAX_LINES = 25;

export const itemsCountLabel = (itemCount: number, locale: string | undefined) => (
  <Translate
    value="pagination_items_count"
    params={{itemCount: itemCount.toLocaleString(locale)}}
  />
);
export const itemsPerPageLabel = (limit: number, locale: string | undefined) => (
  <Translate value="pagination_items_per_page" params={{itemCount: limit.toLocaleString(locale)}} />
);

export function paginate<T>(
  items: T[] | undefined,
  currentPage: number,
  maxLine?: number
): T[] | undefined {
  if (items === undefined) {
    return undefined;
  }
  if (maxLine) {
    const startIndex = (currentPage - 1) * maxLine;
    const endIndex = currentPage * maxLine;
    return items.slice(startIndex, endIndex);
  }
  const startIndex = (currentPage - 1) * PAGINATION_MAX_LINES;
  const endIndex = currentPage * PAGINATION_MAX_LINES;
  return items.slice(startIndex, endIndex);
}
